// Third Party
import dynamic from 'next/dynamic';

const CreateAccountPopupPrivate = dynamic(
  () => import('./create-account-popup-private'),
  {
    ssr: false,
  }
);

export const CreateAccountPopup: React.FC = () => {
  return <CreateAccountPopupPrivate />;
};
